import BaseResource from '@/app-core/lib/data/resource/BaseResource'
import PaymentTypeEnum from '@/app-core/api/enums/PaymentTypeEnum'
import GuestModel from '@/app-core/api/models/customer/GuestModel'
import CheckoutAddressModel from '@/app-core/api/models/checkout/CheckoutAddressModel'

export default class CheckoutPaymentResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.Customer = new GuestModel(payload.Customer ?? null)
    this.Address = new CheckoutAddressModel(payload.Address ?? null)
    this.Payment = payload.Payment ?? PaymentTypeEnum.CASH
    this.QrData = payload.QrData ?? null
    this.Comment = payload.Comment ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
